import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { TextBlock, TextSpan } from '../../../Atoms/Text';

/** The UPSTACK band across the top of the scorer page; the open form also says no Portal account is needed. */
export const ScorerHeaderBand = ({ showsSecureLine }: { showsSecureLine: boolean }) => (
  <header className="flex items-center gap-6 bg-nav-50 px-4 py-6 sm:px-8">
    <TextSpan
      size="lg"
      weight="bold"
      color="white">
      UPSTACK
    </TextSpan>
    <div>
      <TextBlock
        size="lg"
        weight="semibold"
        color="white">
        Secure Scoring Request
      </TextBlock>
      {showsSecureLine && (
        <TextSpan
          size="sm"
          color="grey2"
          className="flex items-center gap-1">
          <LockOutlinedIcon sx={{ fontSize: 14 }} />
          Secure link — no UPSTACK Portal account required
        </TextSpan>
      )}
    </div>
  </header>
);
